import { ChatBubbleOvalLeftIcon } from '@heroicons/react/24/solid'
import { useNavigate, useLocation } from 'react-router-dom'

export default function FloatingChatButton() {
  const navigate = useNavigate()
  const location = useLocation()

  // Hide on app pages (dashboard, chat, etc.)
  if (['/home', '/chat', '/learn', '/bible', '/prayer'].includes(location.pathname)) return null

  return (
    <button
      onClick={() => navigate('/home')}
      className="fixed right-6 z-50 bg-[var(--gold)] text-[var(--text-on-gold)] p-4 rounded-full shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-110 group"
      style={{ bottom: 'max(1.5rem, env(safe-area-inset-bottom))' }}
      aria-label="Open chat"
    >
      <ChatBubbleOvalLeftIcon className="w-6 h-6" aria-hidden="true" />
      <span className="absolute right-full mr-3 top-1/2 -translate-y-1/2 bg-[var(--bg-surface)] text-[var(--text-primary)] text-sm px-3 py-1.5 rounded-lg shadow-lg whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity border border-[var(--glass-border)]">
        Chat with Illuminate Faith
      </span>
    </button>
  )
}
